import { render, staticRenderFns } from "./CollegeShuangZhongwai.vue?vue&type=template&id=0823bf2a&scoped=true"
import script from "./CollegeShuangZhongwai.vue?vue&type=script&lang=js"
export * from "./CollegeShuangZhongwai.vue?vue&type=script&lang=js"
import style0 from "./CollegeShuangZhongwai.vue?vue&type=style&index=0&id=0823bf2a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0823bf2a",
  null
  
)

export default component.exports